import { Component, OnInit } from '@angular/core';
import { VendorDto } from 'src/app/models/VendorDto';
import { VendorsService } from 'src/app/services/vendors.service';
import { ExcelexportService } from 'src/app/services/excelexport.service';
import { NzContextMenuService, NzDropdownMenuComponent } from 'ng-zorro-antd/dropdown';
import * as FileSaver from 'file-saver';
import { NotificationService } from 'src/app/services/notification.service';
import { NotificationType } from 'src/app/models/notification.message';


@Component({
  selector: 'app-view-vendor',
  templateUrl: './view-vendor.component.html',
  styleUrls: ['./view-vendor.component.css']
})
export class ViewVendorComponent implements OnInit {

  contextMenu($event: MouseEvent, menu: NzDropdownMenuComponent, data: any): void {

    ;
        this.nzContextMenuService.create($event, menu);
        this.UpdateVendor = data;
       // this.activeStatus=data.isActive;
      }

  size: number = 0;
  constructor(   private notification: NotificationService,  private vendorService:VendorsService , private nzContextMenuService: NzContextMenuService ) { }
  
  Vendors:VendorDto[] = [];
  loading: boolean = true;
  UpdateVendor:any;
  editDialog:boolean=false;
  viewDialog:boolean=false;
  statuses!: any[];
  submitted!: boolean;
  isEditing:boolean=false;
  exportColumns: string[]=[];


  ngOnInit(): void {

    this.exportColumns=['name','phone','email', 'address','contactPerson','contactPersonEmail','contractorType' ]

 
    this.statuses = [
      {label: 'Sub-Contractor', value: 'Sub-Contractor'},
      {label: 'Third-Party', value: 'Third-Party'}
     
  ];
    this.loadRecords();
  this.loading = false;
  }
  editVendor(vendor: VendorDto) {
    this.UpdateVendor = {...vendor};
    this.editDialog = true;
    this.isEditing = true;
    
}
viewVendor(vendor: VendorDto) {
  this.UpdateVendor = {...vendor};
  this.isEditing = false;
  this.editDialog = true;
  
}


hideDialog() {
  this.editDialog = false;
  this.submitted = false;
}
saveEdit() {
  ;

  this.vendorService.updateVendor(this.UpdateVendor).subscribe({
    next: (data => {
      
      if (data.responseCode == "00") {
        this.notification.sendMessage({
          message: data.message,
          type: NotificationType.success
        });
       this.loadRecords();
       this.isEditing = false;

      }
      else {

        this.notification.sendMessage({
          message: data.message,
          type: NotificationType.error
        });

      }

    }),
    error: ((error: any) => {
      console.log(error.error);
      ;
  

      this.notification.sendMessage({
        message: error.error.message,
        type: NotificationType.error
      });
    })

  });

}
 async  loadRecords()
  {
    let  resVendors = await this.vendorService.getVendors().toPromise(); 
    this.Vendors = <VendorDto[]> resVendors.responseData;
    this.size = this.Vendors.length;

  }
/*
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('p', 'in', [612, 792]);
        //    doc.autoTable(this.exportColumns, this.Vendors);
            (doc as any).autoTable(this.exportColumns, this.Vendors);
            doc.save('Vendors.pdf');
        })
    })
}
*/
exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.Vendors);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "Vendors");
    });
}

saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
}



  downloadExcel() {
    const exportData: Partial<object>[] = this.Vendors.map(
      x => ({


        name: x.name,
        description: x.description,
        phone: x.phone,
        email: x.email,
        address: x.address,
        contactPerson: x.contactPerson,
        contractorType: x.contractorType,
        id: x.id,
        contactPersonEmail:x.contactPersonEmail,


      })
    )
    ExcelexportService.exportArrayToExcel(exportData, 'Contractors List')
  }



}
